var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoggedIn)?_c('div',{staticClass:"cms-block cms-block-login"},[_c('FormLogin',{attrs:{"wide":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }